const Service = {
    convertFileToString(file) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();

            reader.readAsDataURL(file);
            reader.onload = () => {
                let parts = reader.result.split('base64,');
                resolve(parts[1]);
            };
            reader.onerror = error => reject(error);
        });
    }
};

export default Service;
